import { useQuery } from 'react-query';

export default function useApiQuery(key, fetchFn, options = {}) {
  const { data, isLoading, error, refetch, ...rest } = useQuery(key, fetchFn, options);

  return {
    data,
    isLoading,
    error,
    refetch,
    ...rest,
  };
}
